import axios from "axios";
import * as Sentry from '@sentry/react';
import { turingLogger } from '../v3/shared/TuringLogger';
import StatusConstant from '../constants/StatusConstant';
import { pushLog2DV2LogServer } from "../services/logging";
import  * as service from "../services/Auth";
import { AuthConstant } from '../constants';
import { TestsActions } from "../v3/legacy_components/UI_V2_Components/tests/constants"
import { RESET_STATE } from "../v3/legacy_components/UI_V2_Components/Onboarding/OnboardingNewUiUx/onboardingNewUiUx.action";
import { checkJWTExpiration } from "../v3/legacy_components/util/checkJWTExpiration";


const AuthActions = {
  authenticate,
  tokenExpired,
  checkingRedirection,
  logOut
}

function authenticate (payload) {
  return {
    type: AuthConstant.AUTHENTICATE,
    payload
  };
}

function tokenExpired (payload) {
  return {
    type: AuthConstant.TOKEN_EXPIRED,
    payload: { token_expired: payload }
  };
}

function checkingRedirection (payload) {
  return {
    type: AuthConstant.CHECKING_REDIRECTION,
    payload: { checking_redirection: payload }
  };
}

async function logOut(dispatch) {  
  // Paths to bypass authentication redirect
  const bypassAuthRedirectPath = ['/embed/profile'];
  if (bypassAuthRedirectPath.includes(window.location.pathname)) return;

  // Determine redirect URL
  const redirectUrlFromLocalStorage = localStorage.getItem('redirect_url');
  const prefix = window.location.href.includes('/admin/') ? '/admin/login' : '/login';
  const validRedirectURl = redirectUrlFromLocalStorage && redirectUrlFromLocalStorage !== 'null';

  // Perform custom logout logic
  const param = { status: StatusConstant.LOGOUT };
  try {
    const isTokenExpired = checkJWTExpiration(localStorage.getItem('token'));
    if (localStorage.getItem('token') && !isTokenExpired) {
      await service.logout(param); // Logout if token is not expired as this route require token
    }

      dispatch({ type: AuthConstant.TOKEN_EXPIRED, payload: { token_expired: true } });
      dispatch({ type: AuthConstant.AUTHENTICATE, payload: { authenticated: false } });
      dispatch({ type: TestsActions.RESET_DATA });
      dispatch(RESET_STATE)

      clearDocumentAndLocalStorageData();

      if (validRedirectURl) {
        localStorage.setItem('redirect_url', redirectUrlFromLocalStorage);
      }
      const redirect = validRedirectURl ? redirectUrlFromLocalStorage : encodeURIComponent(window.location.pathname + window.location.search);

      // [LOGGING] - SIGN_OUT
      pushLog2DV2LogServer.info("USER_LOGGING", "SIGN_OUT", {}, {}, null);
      turingLogger.log({ eventName: "SIGNOUT", logData: {} }).catch((e) => console.error(e));
      turingLogger.removeIdentity().catch(e => console.error(e));
      window.location.href = `${prefix}?redirect=${redirect}`;
  } catch (error) {
      console.log(error);
      dispatch({ type: AuthConstant.TOKEN_EXPIRED, payload: { token_expired: true } });
      dispatch({ type: AuthConstant.AUTHENTICATE, payload: { authenticated: false } });
      clearDocumentAndLocalStorageData();
      

      // [LOGGING] - SIGN_OUT
      pushLog2DV2LogServer.error("USER_LOGGING", "SIGN_OUT", {}, {}, error);
      turingLogger.error({ eventName: "SIGNOUT_ERR", logData: { error } }).catch((e) => console.error(e));

      const redirect = validRedirectURl ? redirectUrlFromLocalStorage : encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `${prefix}?redirect=${redirect}`;
  }
}

function clearDocumentAndLocalStorageData() {
  // Clear Sentry user
  Sentry.setUser(null);

  // Clear local storage and axios authorization headers
  localStorage.clear();
  delete axios.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common.authorization;

  // Clear cookies
  document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  });  
}


export default AuthActions